<template>
  <div>
    <div class="loginregister">
      <div class="capture">
        <div class="contain">
          <div class="text">
            <h1>
              Get<br />
              Started.
            </h1>
            <p>
              Fill out the form and we’ll get back to you with details and next
              steps.
            </p>
          </div>
          <div class="form">
            <div class="inputs">
              <div class="input">
                <label>First Name</label>
                <input
                  type="text"
                  placeholder="Type here"
                  v-model="user.first_name"
                />
              </div>
              <div class="input">
                <label>Last Name</label>
                <input type="text" v-model="user.last_name" />
              </div>
              <div class="input">
                <label>Email Address</label>
                <input
                  @change="validateUser()"
                  type="text"
                  v-model="user.primary_contact_info.email"
                />
              </div>
              <div class="input">
                <label>Phone Number</label>
                <input
                  v-mask="['(###) ###-####']"
                  type="text"
                  v-model="user.primary_contact_info.phone"
                />
              </div>
              <div class="input full">
                <label>Company</label>
                <input type="text" v-model="user.company" />
              </div>
              <div class="input full">
                <label>How many years have you been in business?</label>
                <v-select
                  :searchable="false"
                  :clearable="false"
                  v-model="questions.years_in_business"
                  :options="['less than 3', '3-5', '6-10', 'over 10']"
                >
                </v-select>
              </div>
              <div class="input full">
                <label>What is the size of your company?</label>
                <v-select
                  :searchable="false"
                  :clearable="false"
                  v-model="questions.company_size"
                  :options="['1-10', '11-25', '25-100', 'over 100']"
                >
                </v-select>
              </div>
              <div class="input full">
                <label
                  >Are you currently reselling for other kiosk
                  manufacturers?</label
                >
                <v-select
                  :searchable="false"
                  :clearable="false"
                  v-model="questions.current_reseller"
                  :options="['Yes', 'No']"
                >
                </v-select>
              </div>
              <div class="input full checkbox">
                <label
                  >I have reviewed the
                  <span @click="show_terms = true" class="terms-text"
                    >Terms of Agreement</span
                  ></label
                >
                <input type="checkbox" v-model="terms" />
              </div>
              <div class="btns">
                <transition name="fade-quick">
                  <button
                    v-if="!registration_status"
                    @click="register()"
                    class="btn"
                  >
                    Become a Reseller
                  </button>
                </transition>
                <transition name="fade-quick">
                  <img
                    class="loader"
                    v-if="registration_status == 'loading'"
                    src="@/assets/img/loader.gif"
                  />
                </transition>
                <transition name="fade-quick">
                  <div class="success" v-if="registration_status == 'success'">
                    <p>
                      You've been Registered!
                      <span
                        >We will get back to you and let you know if you're
                        approved.</span
                      >
                    </p>
                  </div>
                </transition>
              </div>
              <transition name="fade-quick">
                <p v-if="error" class="error">{{ error }}</p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>

    <terms></terms>
  </div>
</template>

<script>
import firebase from "firebase";
import Terms from "@/components/Terms";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;

export default {
  name: "loginregister",
  components: {
    terms: Terms,
  },
  data() {
    return {
      show_terms: false,
      registration_status: false,
      user: {
        requested_at: new Date().getTime(),
        first_name: null,
        last_name: null,
        primary_contact_info: {
          uid: null,
          email: null,
          phone: null,
        },
        company: null,
        reseller_number: 0,
        status: "PENDING",
        address: {
          address_1: "",
          address_2: "",
          address_3: "",
          city: "",
          state: "",
          zip: "",
        },
        notes: [],
      },
      error: null,
      questions: {
        years_in_business: null,
        company_size: null,
        current_reseller: null,
      },
      createAccountForReseller: functions.httpsCallable(
        "popshapCRM-createAccountForReseller"
      ),
      checkForExistingUser: functions.httpsCallable("checkForExistingUser"),
      sendEmail: functions.httpsCallable("sendEmail"),
    };
  },
  methods: {
    validate() {
      this.error = null;
      let valid = true;
      let user = this.user;

      for (let key in user) {
        if (key == "name" || key == "company") {
          if (!user[key]) valid = false;
        } else if (key == "contact_info") {
          for (let key2 in user[key]) {
            if (!user[key][key2]) valid = false;
          }
        }
      }

      for (let key in this.questions) {
        if (!this.questions[key]) valid = false;
      }

      if (!valid) {
        this.error = "Please enter all fields";
      } else {
        if (!this.terms) {
          this.error = "Please accept the terms";
          return false;
        }
      }
      return valid;
    },
    register() {
      if (this.validate()) {
        this.registration_status = "loading";
        let user = this.user;
        for (let key in this.questions) {
          let note = {
            question: key,
            answer: this.questions[key],
          };
          user.notes.push(note);
        }
        this.createAccountForReseller(user)
          .then((res) => {
            let reseller_id = res.data.reseller_id;
            this.sendEmail({
              template_name: "popshap-new-register",
              from_email: null,
              to_email: [
                {
                  email: "eitan@popshap.com",
                  type: "to",
                },
                {
                  email: "modi@popshap.com",
                  type: "to",
                },
              ],
              global_merge_vars: [
                {
                  name: "LINK",
                  content: `https://crm.popshap.com/reseller/${reseller_id}`,
                },
                {
                  name: "NAME",
                  content: `${this.user.first_name} ${this.user.last_name}`,
                },
              ],
            });
          })
          .then(() => {
            this.registration_status = "success";
            setTimeout(() => {
              this.user = {
                requested_at: new Date().getTime(),
                first_name: null,
                last_name: null,
                primary_contact_info: {
                  uid: null,
                  email: null,
                  phone: null,
                },
                company: null,
                status: "PENDING",
                address: {
                  address_1: "",
                  address_2: "",
                  address_3: "",
                  city: "",
                  state: "",
                  zip: "",
                },
                notes: [],
              };
              this.questions = {
                years_in_business: null,
                company_size: null,
                current_reseller: null,
              };
            }, 30000);
          })
          .catch((err) => {
            this.error = "err.message";
          });
      }
    },
    async validateUser() {
      let email = this.user.primary_contact_info.email;

      this.checkForExistingUser(email).then((res) => {
        if (!res.data) {
          this.user.primary_contact_info.email = null;
          this.error = "This user is already registered";
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.capture {
  background: white;
  .contain {
    min-height: 100vh;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    @media screen and (max-width: 800px) {
      flex-direction: column;
    }
    & > div {
      width: 45%;
      @media screen and (max-width: 800px) {
        width: 100%;
      }
    }
    .inputs {
      @media screen and (max-width: 800px) {
        width: 100%;
        margin-top: 50px;
      }
      .input {
        // @media screen and (max-width: 800px){
        //   width: 100%;
        // }
      }
      .btns {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        .loader {
          height: 50px;
          filter: brightness(0.96);
        }
        .success {
          font-size: 25px;
          color: #49c6d4;
          font-weight: bold;
          span {
            display: block;
            color: #132628;
            font-weight: normal;
            margin-top: 10px;
            font-size: 17px;
          }
        }
      }
    }
  }
}

.home .loginregister .contain {
  min-height: auto;
}

.v-select {
  max-width: 100% !important;
  margin-bottom: 15px;
  @media screen and (min-width: 1500px) {
    margin-bottom: 20px;
  }
}

.terms-text {
  color: #49c6d4;
  font-weight: bold;
  cursor: pointer;
}

.checkbox {
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 15px;
  position: relative;
  input {
    width: auto;
    margin: 0;
    margin-right: 10px;
    position: absolute;
    z-index: 2;
    left: 0;
    cursor: pointer;
  }
  label {
    margin-bottom: 0;
    padding-left: 25px;
  }
}

.loader {
  filter: none !important;
}
</style>
